import * as z from 'zod';

export const formatZodError = (error: z.ZodError, data: unknown): string => {
  const details = error.issues.map((err) => `- Champ "${err.path.join('.')}" : ${err.message}`).join('\n');
  const errroMsg = `${details}\n\nDonnées reçues: ${JSON.stringify(data, null, 2)}`;
  console.error(errroMsg);
  return errroMsg;
};
